import * as userRequest from "@/utils/userRequest";

export default async function createConnectSocialService(
    token: string,
    state: string,
    type: string,
    action: string,
    onSuccess?: (data?: any) => any,
    handleError?: (err?: any) => any
) {
    try {
        const res = await userRequest.post(
            "auth/state",
            {
                state,
                type,
                action,
            },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        if (res) {
            onSuccess && onSuccess(res);
            return res;
        }
    } catch (err) {
        console.error("🚀 ~ createConnectSocialService ~ err:", err);
        handleError && handleError(err);
        throw err;
    }
}
